module.exports = __webpack_public_path__ + "static/media/S-7-Y.1ec88e74.mp3";